import { getAwsAssets } from "@src/utils";
import { formatCurrency } from "@src/utils/currencyFormatter";
import { t } from "i18next";
import { useRouter } from "@src/lib/router";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  applyCourseCouponAction,
  getGraphCoursePriceDetailsAction,
  setValidity,
  showCouponModal,
  setCouponCodeAction,
} from "../../store/actions";
import CouponModal from "./CouponModal";
import styles from "./MultipleValidityModal.module.scss";
import MultipleValidityCardListing from "./MultipleValidityCardListing";

function MultipleValidityModal({ data, onClose }) {
  const dispatch = useDispatch();
  const router = useRouter();

  const isCouponModal = useSelector(
    (state) => state?.overviewReducer?.isCouponModal
  );
  const promotedValidity = useSelector(
    (state) => state.overviewReducer.promotedValidity
  );

  const [selectedValidity, setSelectedvalidity] = useState(promotedValidity);
  const handleSelectedData = (data) => {
    setSelectedvalidity(data);
  };

  const onClickHandler = () => {
    localStorage.setItem(
      "selectedValidity",
      JSON.stringify({ courseId: router?.query?.courseId, ...selectedValidity })
    );
    dispatch(setValidity(selectedValidity));
    dispatch(
      getGraphCoursePriceDetailsAction({
        courseIds: [`${router.query.courseId}`],
        isBundlingCourse: false,
        avoidCouponsList: true,
        ocvmId: selectedValidity?.id || null,
      })
    );
    onClose();
  };

  const closeCouponModal = useCallback(() => {
    dispatch(showCouponModal({ isCouponModal: false }));
    onClose();
  }, []);

  return (
    <>
      {isCouponModal && <CouponModal onClose={closeCouponModal} />}
      <div className={styles.modal} onClick={onClose}>
        <div
          className={styles.modalContent}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.modalHeader}>
            <div className={styles.modalHeading}>
              {t(
                "components.tabs.overview.components.multipleValidity.multipleValidityModal.changeCourseValidity",
                "Change course validity"
              )}
            </div>
            <img
              src={getAwsAssets("crossIcon.svg", "content")}
              alt="crossIcon"
              height={24}
              width={24}
              onClick={onClose}
            />
          </div>
          <div className={styles.modalBody}>
            <MultipleValidityCardListing data={data} handleSelectedData={handleSelectedData}/>
            <button className={styles.button} onClick={onClickHandler}>
              {t(
                "components.tabs.overview.components.multipleValidity.multipleValidityModal.button",
                "Done"
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default MultipleValidityModal;
